import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

/* TODO: Review: Don't know where this token is supposed to be retreived from.  It is currently hard-coded */
const AUTH_TOKEN = 'DFGw20LbVc6YZJnNXkQAu1JiZgsO7ObRB1UpuGHasdfdYIYIY764QWERKJHGKSVN';
//const AUTH_TOKEN = 'Vzjr0LbVc6YZJnNXkQAu1JiZgsO7ObRB1UpuGHFyWMRUtexHu2x5xwjFbtA8 ';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    req = req.clone({
      setHeaders: {
        'Content-Type' : 'application/json; charset=utf-8',
        'Accept'       : 'application/json',
        'Authorization': `Bearer ${AUTH_TOKEN}`,
      },
    });

    return next.handle(req);
  }
}



// WEBPACK FOOTER //
// ./src/app/distributor/services/auth-interceptor.ts